import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForgotPasswordMutation } from '../store/api/authApi'
import toast from 'react-hot-toast'

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('')
  const [forgotPassword, { isLoading, isSuccess }] = useForgotPasswordMutation()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      await forgotPassword({ email }).unwrap()
      toast.success('If that email has an admin account, a reset link was sent.')
    } catch (err: any) {
      toast.error(err?.data?.message || 'Failed to send reset email')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-6">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">Recover password</h1>
        <p className="text-gray-600 mb-6">
          Enter your admin email. We will send a reset link to that address only.
        </p>

        {isSuccess ? (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-sm text-green-800 mb-4">
            Check your inbox for a reset link. If you do not see it, verify you used the same email invited to the admin panel.
          </div>
        ) : null}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="you@school.edu"
              required
              disabled={isLoading}
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50"
          >
            {isLoading ? 'Sending...' : 'Send reset link'}
          </button>
        </form>

        <p className="mt-4 text-sm text-center text-gray-500">
          <Link to="/login" className="text-blue-600 hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}

export default ForgotPassword
